export default __webpack_public_path__ + "static/002-38a57f389dc9df49cacca926e0716b98.jpg";